import { render, staticRenderFns } from "./EventStake.vue?vue&type=template&id=d0116226&"
import script from "./EventStake.vue?vue&type=script&lang=js&"
export * from "./EventStake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports